import { baseFetch } from '../../../api/baseFetch';
import { FarmOrgAccessResponseSchema } from './farm-orgs.schema';

export const getOrgsWithFarmAccess = (
  solarFarmId: number,
  solarFarmOrgId: number,
) => {
  return baseFetch(
    'auth',
    `/org-permissions/orgs/${solarFarmOrgId}/solar_farms/${solarFarmId}/permissions`,
    FarmOrgAccessResponseSchema.defined(),
    {
      searchParams: {
        user_type: 'org',
      },
    },
  );
};
